module.exports = __webpack_public_path__ + "img/found-exhibit.905a1e17.png";